module.exports = __webpack_public_path__ + "static/media/ip.c1aaa94d.png";